import { BaseTooltipHandler } from "../base";

import { getDomStyles } from "./utils";

import { TooltipModel } from "./model/tooltip-model";

import { TOOLTIP_CONTAINER_EL_CLASS_NAME } from "../constants";

import { hasParentElement, isNil } from "@visactor/vutils";

import { domDocument } from "../../../../util/env";

import { registerComponentPlugin } from "../../register";

import { DEFAULT_TOOLTIP_Z_INDEX } from "./constant";

import { TooltipHandlerType } from "../../../../component/tooltip/constant";

export class DomTooltipHandler extends BaseTooltipHandler {
    getVisibility() {
        var _a;
        return !!(null === (_a = this.model) || void 0 === _a ? void 0 : _a.getVisibility());
    }
    setVisibility(_value) {
        var _a;
        _value !== this.getVisibility() && (null === (_a = this.model) || void 0 === _a || _a.setVisibility(_value));
    }
    constructor() {
        super(DomTooltipHandler.type), this.type = TooltipHandlerType.dom, this._tooltipContainer = null == domDocument ? void 0 : domDocument.body;
    }
    onAdd(service) {
        super.onAdd(service), this._initStyle(), this.initEl();
    }
    initEl() {
        const tooltipSpec = this._component.getSpec(), parentElement = tooltipSpec.parentElement;
        if (domDocument && parentElement) {
            for (let i = 0; i < parentElement.children.length; i++) if (parentElement.children[i].classList.contains(TOOLTIP_CONTAINER_EL_CLASS_NAME)) {
                this._container = parentElement.children[i];
                break;
            }
            this._container || (this._container = domDocument.createElement("div"), this._container.style.position = "relative", 
            this._container.style.zIndex = DEFAULT_TOOLTIP_Z_INDEX, this._container.classList.add(TOOLTIP_CONTAINER_EL_CLASS_NAME), 
            parentElement.appendChild(this._container)), this.model = new TooltipModel({
                valueToHtml: this._option.sanitize,
                getTooltipStyle: () => this._domStyle,
                getTooltipActual: () => this._tooltipActual,
                getTooltipAttributes: () => this._attributes,
                getContainer: () => this._container
            }, [ tooltipSpec.className ], this.name);
        }
    }
    _removeTooltip() {
        var _a;
        null === (_a = this.model) || void 0 === _a || _a.release(), this._container = null;
    }
    _updateTooltip(visible, params) {
        var _a, _b;
        const {tooltipActual: tooltipActual, tooltipSpec: tooltipSpec} = params;
        if (visible && this.model) {
            if (!params.changePositionOnly) {
                this._tooltipActual = tooltipActual, this._initStyle();
                const firstInit = !this.model.product;
                this.model.initAll(), firstInit && this._initEvent(this.model.product), this.model.setStyle(), 
                this.model.setContent();
            }
            this.setVisibility(visible);
            const el = this.model.product;
            if (el) {
                const {x: x = 0, y: y = 0} = null !== (_a = tooltipActual.position) && void 0 !== _a ? _a : {};
                if (tooltipSpec.updateElement) {
                    this._updatePosition(null !== (_b = this._cacheCustomTooltipPosition) && void 0 !== _b ? _b : {
                        x: x,
                        y: y
                    }), tooltipSpec.updateElement(el, tooltipActual, params);
                    const position = this._getActualTooltipPosition(tooltipActual, params, {
                        width: el.offsetWidth,
                        height: el.offsetHeight
                    });
                    this._updatePosition(position), this._cacheCustomTooltipPosition = position;
                } else this._updatePosition({
                    x: x,
                    y: y
                });
            }
        } else this.setVisibility(visible), this._cacheCustomTooltipPosition = void 0;
    }
    _initStyle() {
        this._domStyle = getDomStyles(this._attributes);
    }
    _getParentElement(spec) {
        var _a;
        return null !== (_a = this._container) && void 0 !== _a ? _a : super._getParentElement(spec);
    }
    isTooltipShown() {
        return this.getVisibility();
    }
    reInit() {
        super.reInit(), this._initStyle();
    }
    _updatePosition({x: x, y: y}) {
        const el = this.model.product;
        el && (el.style.transform = `translate3d(${x}px, ${y}px, 0)`);
    }
    _initEvent(el) {
        el.addEventListener("pointerleave", (event => {
            const {renderMode: renderMode, enterable: enterable} = this._component.getSpec(), relatedTarget = event.relatedTarget;
            "html" === renderMode && enterable && (isNil(relatedTarget) || relatedTarget !== this._compiler.getCanvas() && !hasParentElement(relatedTarget, this.getTooltipContainer())) && this._component.hideTooltip();
        }));
    }
}

DomTooltipHandler.type = TooltipHandlerType.dom;

export const registerDomTooltipHandler = () => {
    registerComponentPlugin(DomTooltipHandler);
};
//# sourceMappingURL=dom-tooltip-handler.js.map
